export default {
  tags: state => state.tags,
}
